import { COVERGO_SAAS_DEV, COVERGO_EU_DEV, COVERGO_EU_PROD, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const aevitae = {
	"aevitae-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "aevitae_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"aevitae-studio-uat.covergo.cloud": {
		appConfig: {
			tenantId: "aevitae_uat",
			appId: "admin_portal",
		},
		envConfig: COVERGO_EU_DEV,
	},
	"aevitae-studio.eu.covergo.com": {
		appConfig: {
			tenantId: "aevitae",
			appId: "admin_portal",
		},
		envConfig: COVERGO_EU_PROD,
	},
	"aevitae-studio-qa.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "aevitae_qa",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	}
}
